import { db } from '../firebase';
import { doc, setDoc } from 'firebase/firestore';

// Call this after client registration to create a client profile in Firestore
export async function createClientProfile({ uid, email, name, phone }) {
  await setDoc(doc(db, 'clients', uid), {
    email,
    name,
    phone,
    createdAt: new Date().toISOString(),
  });
}
